import React from 'react'
import './Portfolio.css'
import {FaGithub} from "react-icons/fa";

export default function Portfolio() {
  return (
    <>
        <section id='portfolio'>
            <div id='portfolio-container'>
                <div className="portfolio-headline">
                    <p> My Recent Works </p>
                    <h1> Portfolio </h1>
                </div>

                <div className="portfolio-content">
                    <div className='portfolio-cards'>
                        <div className='portfolio-cards-container'>
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/1.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> Grand Hyatt Clone Website </h3>
                                <p> HTML, CSS, Javascript </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/grand-hyatt-clone-website" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/2.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> Amanjiwo Clone Website </h3>
                                <p> HTML, CSS, Bootstrap </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/amanjiwo-website-clone" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/3.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> Senayan Mulia Clone Website </h3>
                                <p> HTML, CSS, Bootstrap </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/senayan-mulia-clone" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/4.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> Dapur Solo Clone Website </h3>
                                <p> HTML, CSS, Bootstrap </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/dapur-solo-clone" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/5.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> RestoRindo Website </h3>
                                <p> HTML, CSS, Bootstrap, Javascript </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/restorindo-website" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/6.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> Park Hyatt Clone Website </h3>
                                <p> HTML, CSS, Bootstrap </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/park-hyatt-clone" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/7.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> HeyHealth Healthcare Website Front-End </h3>
                                <p> ReactJS </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/heyhealth-website-frontend" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='portfolio-cards'>
                        <div className="portfolio-cards-container">
                            <div className='portfolio-cards-image'>
                                <img src="/portfolio/7.jpeg" alt="" />
                            </div>

                            <div className='portfolio-cards-text'>
                                <h3> HeyHealth Healthcare Website Back-End </h3>
                                <p> Python & Django </p>
                            </div>

                            <div className='portfolio-cards-button'>
                                <a href="https://github.com/owenmarss/heyhealth-website-backend" target='__blank'>
                                    <button> <FaGithub/> Github </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
